<template>

  <div>
    <Loader cover v-if="local.isProcessing"/>

    <div class="vx-row">
      <div class="vx-col sm:w-2/3 w-full mb-4">
        <CourseOutlineInfo :courseOutline="local.courseOutlineId"/>
      </div>
      <div class="vx-col sm:w-1/3 w-full mb-4">
        <VdoSetInfo/>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full">
        <VdoSetUnitEdit/>
      </div>
    </div>

    <!----------------------------------------- Actions Button ---------------------------------------------------->
    <div class="vx-row pt-2">
      <div class="vx-col w-full">
        <vs-button @click.prevent="onBackClick" color="success"
                   :disabled="isUploading"
                   type="border">
          {{ $t('general.back') }}
        </vs-button>
      </div>
    </div>

  </div>

</template>

<script>
  import {state} from './data';

  import CourseOutline from '@/store/modules/courses/course-outline/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";

  if (!state.store.CourseOutline) state.registerModule(`CourseOutline`, CourseOutline);

  const {
    mapActions: mapCourseOutlineActions,
  } = createNamespacedHelpers(`CourseOutline`);


  const {
    mapFields: mapCourseOutlineFields,
  } = createHelpers({
    getterType: `CourseOutline/getField`,
    mutationType: `CourseOutline/updateField`,
  });

  export default {
    props: {
      courseOutlineId: {
        type: String,
        require: true,
      }
    },
    components: {
      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
      CourseOutlineInfo: () => import('./SubComponents/CourseOutlineInfo'),
      VdoSetInfo: () => import('./SubComponents/VdoSetInfo'),
      VdoSetUnitEdit: () => import('./SubComponents/VdoSetUnitEdit'),
    },
    computed: {
      ...mapCourseOutlineFields({
        courseOutlineProcessing: 'processing',
      }),
      isUploading() {
        return this.local.isUploading;
      },
    },
    watch: {
      courseOutlineProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    data() {
      return {
        store: state.store,
        local: state.local,

      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapCourseOutlineActions({
        getCourseOutline: 'getCourseOutline',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onBackClick() {
        this.$router.push(
          {
            name: "vdo-set",
          }
        );
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async loadData() {
        // this.local.classSections = await this.getClassSectionsByFilter(payload);
        let localCourseOutline = await this.getCourseOutline({id: this.$route.params.courseOutlineId});
        // deep copy state to local variables so we can edit them
        this.local.vdoSetEdit.courseOutline = JSON.parse(JSON.stringify(localCourseOutline));

        //set vdoSet selected item
        if (this.local.vdoSetEdit.courseOutline.vdoSets && this.local.vdoSetEdit.courseOutline.vdoSets.length > 0) {
          this.local.vdoSetInfo.selectedVdoSet = this.local.vdoSetEdit.courseOutline.vdoSets[0];
          //set vdoSetUnit selected item
          if (this.local.vdoSetInfo.selectedVdoSet.vdoSetUnits && this.local.vdoSetInfo.selectedVdoSet.vdoSetUnits.length > 0) {
            this.local.vdoSetUnitEdit.selectedVdoSetUnit = this.local.vdoSetInfo.selectedVdoSet.vdoSetUnits[0];
          }else{
            this.local.vdoSetInfo.selectedVdoSet.vdoSetUnits = [];
          }
          //set vdoSetTopic
        }else{
          this.local.vdoSetEdit.courseOutline.vdoSets = []
        }

      },

    },
    async created() {
      await this.loadData();
    },
  }
</script>

<style scoped>

</style>
